import { Flex } from "antd";

import { CompanyRole, UserListEntity, UserScope } from "interfaces";
import { EditRolesButton } from "./EditRoles";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ListOfRoles } from "./ListOfRoles";

interface IProps {
  roles: UserScope[];
  companyInfo: {
    id: string;
    role: CompanyRole;
    companyName: string;
    companyRegistrationNumber: string;
  };
  userInfo: UserListEntity;
}

export const UserRoleList = observer((props: IProps) => {
  const { user } = useStores();
  const { isUserAdmin } = user.roles;
  return (
    <Flex align="center" gap="large">
      <ListOfRoles roles={props.roles} />
      {isUserAdmin && <EditRolesButton {...props} />}
    </Flex>
  );
});
